import facebook from './SocialLinks/icons/icon-facebook.svg';
import instagram from './SocialLinks/icons/icon-instagram.svg';
import linkedin from './SocialLinks/icons/icon-linkedin.svg';
import twitter from './SocialLinks/icons/icon-twitter.svg';
var year = new Date().getFullYear();
var urlFrenchFRCA = process.env.LOCALE === 'fr' ? '/fr-ca' : '';
var frOrEN = (process.env.LOCALE || 'en').slice(0, 2);
export var disclaimer = "\xA9 ".concat(year, " CARFAX Canada ULC. All rights reserved.");
var determineEnvironment = function determineEnvironment() {
  return typeof window !== 'undefined' && window.location ? window.location.origin : 'https://www.carfax.ca';
};
export var LEVEL = determineEnvironment();
export var productLinks = {
  title: "Products",
  links: [{
    key: 'vehicle-history-reports',
    text: "CARFAX Canada Vehicle History Reports",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/vehicle-history-reports")
  }, {
    key: 'service',
    text: "CARFAX Canada Car Care",
    url: "".concat(LEVEL, "/Service"),
    openInNewTab: true
  }, {
    key: 'history-based-value',
    text: "CARFAX Canada History-Based Value",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/history-based-value")
  }, {
    key: 'recall-check',
    text: "CARFAX Canada Recall Check",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/recall-check")
  }, {
    key: 'vin-decode',
    text: "CARFAX Canada VIN Decoder",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/vin-decode")
  }]
};
export var resourceLinks = {
  title: "Resources",
  links: [{
    text: "Blog",
    url: "".concat(LEVEL, "/resource-centre").concat(urlFrenchFRCA),
    key: 'blog'
  }, {
    text: "Support Centre",
    url: "https://support.carfax.ca/".concat(frOrEN, "/support/home"),
    key: 'support',
    openInNewTab: true
  }, {
    text: "Press Centre",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/press-centre"),
    key: 'press'
  }]
};
export var aboutLinks = {
  title: "Company",
  links: [{
    text: "About Us",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax"),
    key: 'about'
  }, {
    text: "Contact",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/contact"),
    key: 'contact'
  }, {
    text: "Careers",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/careers"),
    key: 'careers'
  }, {
    text: "Partners",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/our-partners"),
    key: 'partners'
  }, {
    text: "CARFAX Canada Data",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/vehicle-history-data"),
    key: 'vehicle-history-data'
  }, {
    text: "CARPROOF is CARFAX Canada",
    url: "".concat(LEVEL, "/resource-centre").concat(urlFrenchFRCA, "/articles/carproof"),
    key: 'carproof'
  }]
};
export var learnLinks = {
  title: "Dealer Services",
  links: [{
    text: "Dealer Login",
    url: "https://dealer.carfax.ca/",
    key: 'dealer-login'
  }, {
    text: "Advantage Dealers",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/advantage-dealers"),
    key: 'advantage-dealer'
  }, {
    text: "Become A Dealer Member",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/become-a-member"),
    key: 'become-a-member'
  }]
};
export var legalLinks = {
  links: [{
    text: "Privacy / Legal",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/privacy-legal"),
    key: 'privacy-legal'
  }, {
    text: "Accessibility",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/accessibility"),
    key: 'accessibility'
  }, {
    text: "Conditions Of Use",
    url: "".concat(LEVEL).concat(urlFrenchFRCA, "/about-carfax/privacy-legal/conditions-of-use"),
    key: 'conditions-of-use'
  }]
};
export var siteMapLinks = [productLinks, resourceLinks, aboutLinks, learnLinks];
export var socialLinks = [{
  text: 'facebook',
  url: 'https://www.facebook.com/CARFAXCanada/',
  key: 'facebook',
  iconName: 'facebook'
}, {
  text: 'instagram',
  url: "https://www.instagram.com/carfaxca/?hl=".concat(frOrEN),
  key: 'instagram',
  iconName: 'instagram'
}, {
  text: 'linkedin',
  url: 'https://www.linkedin.com/company/carfax-canada/',
  key: 'linkedin',
  iconName: 'linkedin'
}, {
  text: 'twitter',
  url: 'https://twitter.com/CARFAXca',
  key: 'twitter',
  iconName: 'twitter'
}];
export var iconList = {
  facebook: facebook,
  instagram: instagram,
  linkedin: linkedin,
  twitter: twitter
};